// @ts-nocheck
import { createAction, createAsyncAction } from '../../../core/store/actionCreators';
import {
  CLOSE_CUSTOMER,
  CREATE_USER,
  FETCH_CUSTOMER,
  FETCH_PARTNERS,
  FETCH_REGIONS,
  LOGOUT_ALL_DEVICES,
  REMOVE_BLOCKS,
  REOPEN_CUSTOMER,
  RESET_PASSWORD,
  SEARCH_CUSTOMERS,
  SEND_VERIFICATION_EMAIL,
  SET_SEARCH_PARAMS,
  SKIP_MFA,
  UPDATE_CUSTOMER,
} from './customerActionTypes';
import UserService from '../services/UserService';
import UserPreferencesService from '../services/UserPreferencesService';
import PartnerService from '../services/PartnerService';
import CustomerService from '../services/CustomerService';

export const searchCustomers = createAsyncAction(SEARCH_CUSTOMERS, async (params, page, limit) => {
  const { data } = await UserService.searchUsers(params, page, limit);
  return data;
});

export const fetchCustomer = createAsyncAction(FETCH_CUSTOMER, async userId => {
  const { data } = await UserService.fetchUser(userId);
  return data;
});

export const fetchRegions = createAsyncAction(FETCH_REGIONS, async () => {
  const { data } = await UserPreferencesService.fetchRegions();
  return data;
});

export const fetchPartners = createAsyncAction(FETCH_PARTNERS, async () => {
  const { data } = await PartnerService.fetchPartners();
  return data;
});

export const updateCustomer = createAsyncAction(UPDATE_CUSTOMER, async (userId, userData) => {
  const { data } = await UserService.updateUser(userId, userData);
  return data;
});

export const sendVerificationEmail = createAsyncAction(SEND_VERIFICATION_EMAIL, async userId => {
  const { data } = await UserService.sendVerificationEmail(userId);
  return data;
});

export const sendPasswordResetEmail = createAsyncAction(RESET_PASSWORD, async userId => {
  const { data } = await UserService.sendPasswordResetEmail(userId);
  return data;
});

export const skipMfa = createAsyncAction(SKIP_MFA, async (userId) => {
  const { data } = await CustomerService.registerFlow(userId, 'mfaWhitelist');
  return data;
});

export const logoutAllDevices = createAsyncAction(LOGOUT_ALL_DEVICES, async userId => {
  const { data } = await UserService.logoutAllDevices(userId);
  return data;
});

export const closeCustomer = createAsyncAction(CLOSE_CUSTOMER, async userId => {
  const { data } = await UserService.closeUser(userId);
  return data;
});

export const reopenCustomer = createAsyncAction(REOPEN_CUSTOMER, async userId => {
  const { data } = await UserService.reopenUser(userId);
  return data;
});

export const removeBlocks = createAsyncAction(REMOVE_BLOCKS, async userId => {
  const { data } = await UserService.removeBlocks(userId);
  return data;
});

export const createUser = createAsyncAction(CREATE_USER, async userData => {
  const { data } = await UserService.createUser(userData);
  return data;
});

export const setSearchParams = createAction(SET_SEARCH_PARAMS);
